import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { getLocation } from 'ducks/router'
import { useModal } from 'hooks'
import { candidates } from 'orm'

const useSelectCandidateModalQueries = () => {
  const dispatch = useDispatch()

  const handleFetchCandidates = React.useCallback(
    (
      { projectId },
      { limit, offset, ordering, search, is_favourite, hire_status },
    ) => {
      dispatch(
        candidates.fetchStart({
          project: projectId,
          limit,
          offset,
          ordering,
          search,
          is_favourite,
          hire_status,
          status: ['completed'],
        }),
      )
    },
    [dispatch],
  )

  return {
    handleFetchCandidates,
  }
}

const useSelectCandidateModalMutations = () => {
  const dispatch = useDispatch()

  const handleSelectCandidate = React.useCallback(
    (
      { id },
      { postSuccessAction }: { postSuccessAction?: () => void } = {},
    ) => {
      dispatch(
        candidates.patchStart({
          pk: id,
          data: { status: 'screened' },
          postSuccessAction,
        }),
      )
    },
    [dispatch],
  )

  return {
    handleSelectCandidate,
  }
}

export const useSelectCandidateModal = state => {
  const { id, projectId } = state

  const { query = {} } = useSelector(getLocation)

  const { handleClose, handleOpen, isOpen } = useModal()

  const { handleFetchCandidates } = useSelectCandidateModalQueries()

  const { handleSelectCandidate } = useSelectCandidateModalMutations()

  const handlePostSuccessAction = React.useCallback(() => {
    handleClose()
    handleFetchCandidates({ projectId }, query)
  }, [projectId, query, handleClose, handleFetchCandidates])

  const handleConfirm = React.useCallback(() => {
    handleSelectCandidate(
      { id },
      { postSuccessAction: handlePostSuccessAction },
    )
  }, [id, handlePostSuccessAction, handleSelectCandidate])

  return {
    handleSelectCandidateModalClose: handleClose,
    handleSelectCandidateModalConfirm: handleConfirm,
    handleSelectCandidateModalOpen: handleOpen,
    isSelectCandidateModalOpen: isOpen,
  }
}
